<div class="button-group">
	<cp-button-widget *ngFor="let btn of buttons; first as firstBtn; last as lastBtn"
					  [ngClass]="setButtonClasses(firstBtn, lastBtn)"
					  [button]="btn"
					  (onClick)="onButtonClick(btn)">
	</cp-button-widget>
</div>
